module.exports = __webpack_public_path__ + "static/media/bien-etre.34bd6320.webp";